import * as React from 'react';

// Hooks
import {
  useTranslation,
  config,
  isWebBridgeSupported,
} from '@shopee-user/platform';

// Utils
import { constants } from '@shopee-user/business-customization-logic';
import { forwardOrAppendAuthParamsIfNotExist } from '@shopee-user/authentication-utils';
import {
  BusinessTarget,
  BusinessTargetConfig,
  EnvConfig,
  LocaleDomainSuffixConfig,
} from '@shopee-user/global';
import {
  isFeatureEnabled as isStaticFeatureEnabled,
  Feature as StaticFeature,
} from '@shopee-user/static-feature-toggle';

import styles from './style.scss';

export default function AlternativeLoginEntrance() {
  const I18n = useTranslation();

  const preventFormSubmitOnEnter = (
    event: React.KeyboardEvent<HTMLAnchorElement>
  ) => {
    if (event.key === 'Enter') event.stopPropagation();
  };

  const otherTarget = BusinessTarget.Spx;
  const useProxy =
    !isWebBridgeSupported() &&
    isStaticFeatureEnabled(StaticFeature.LoginUseProxyDomain, false);
  const domain = useProxy
    ? `https://account.${EnvConfig[config.ENV].subDomainPrefix}spx.${
        LocaleDomainSuffixConfig[config.LOCALE]
      }`
    : BusinessTargetConfig[otherTarget].getDomain(config.ENV, config.LOCALE);
  const href = forwardOrAppendAuthParamsIfNotExist(
    `${domain}${constants.AUTHENTICATION_ENTRY_URL}`
  );

  return (
    <div className={styles.altLoginLink}>
      {I18n.tNode('msg_auth_alt_main_log_in', {
        alt_login_link: (
          <a
            className={styles.link}
            href={href}
            onKeyDown={preventFormSubmitOnEnter}
          >
            {I18n.t('label_auth_alt_log_in_here')}
          </a>
        ),
      })}
    </div>
  );
}
